import { render } from "./PlayerWrap.vue?vue&type=template&id=46b7aaff&scoped=true"
import script from "./PlayerWrap.vue?vue&type=script&lang=js"
export * from "./PlayerWrap.vue?vue&type=script&lang=js"

import "./PlayerWrap.vue?vue&type=style&index=0&id=46b7aaff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b7aaff"]])

export default __exports__